import React, { useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import {
  Header, H2, H5,
  P, Row, Icon, Styles,
  Modal, ModalHeader, ModalBody
} from '@contently/toolkit';

const { colors } = Styles;

// have to override platform styles
const FullHeader = styled(Header)`
  max-width: none !important;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 480px) {
    flex-direction: column;
  }
`;

const ContentPortalHeader = props => {

  const { name, children } = props;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <FullHeader>
      <H2>
        {name}

        <Icon
          type="question-circle"
          color={colors.blue.primary}
          onClick={() => setModalOpen(!modalOpen)}
        />
      </H2>

      {children}

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(!modalOpen)}>
        <ModalHeader>Content portal analytics</ModalHeader>
        <ModalBody>
          <Row>
            <H5>Total visits</H5>
            <P>
              Displays the number of times a user visited the content portal or Salesforce Contently
              tab to look for content.
            </P>
          </Row>

          <Row>
            <H5>New content requested</H5>
            <P>
              Displays the number of times a user tried to request a new piece of content from the
              portal.
            </P>
          </Row>

          <Row>
            <H5>Total links clicked</H5>
            <P>
              Displays total number of times your internal users opened and viewed a piece of
              content from the portal.
            </P>
          </Row>

          <Row>
            <H5>Total content shares</H5>
            <P>
              Displays the total number of times a piece of content was shared with another user. It
              combines the number of times a link to content piece was copied and the number of
              times it was emailed using Salesforce's email functionality.
            </P>
          </Row>

          <Row>
            <H5>Shared content views</H5>
            <P>
              Displays the number of times a piece of content was opened by the end user who received this
              piece of content.
            </P>
          </Row>

          <Row>
            <H5>Appeared in portal</H5>
            <P>Displays the number of times a piece of content was surfaced in the portal.</P>
          </Row>
          <Row></Row>
        </ModalBody>
      </Modal>
    </FullHeader>
  );
};

ContentPortalHeader.defaultProps = {
  children: null
};

ContentPortalHeader.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.element
};

export default ContentPortalHeader;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_portals/header.jsx